/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CertificateUpdate
 */
export interface CertificateUpdate {
    /**
     * 
     * @type {string}
     * @memberof CertificateUpdate
     */
    certificate: string;
    /**
     * 
     * @type {string}
     * @memberof CertificateUpdate
     */
    key?: string;
}

export function CertificateUpdateFromJSON(json: any): CertificateUpdate {
    return CertificateUpdateFromJSONTyped(json, false);
}

export function CertificateUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CertificateUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'certificate': json['certificate'],
        'key': !exists(json, 'key') ? undefined : json['key'],
    };
}

export function CertificateUpdateToJSON(value?: CertificateUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'certificate': value.certificate,
        'key': value.key,
    };
}


